export default __webpack_public_path__ + "static/media/halfleavevector.4408d32b.svg";